var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4",
    gradientUnits: "userSpaceOnUse",
    x1: 1047.862,
    y1: -719.132,
    x2: 1048.862,
    y2: -719.132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M120.848 110.597v-3.746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M119.919 91.089c-3.742 7.225-11.286 12.163-19.984 12.163-8.828 0-16.467-5.086-20.149-12.487M127.245 54.406c.1.961.151 1.937.151 2.925 0 15.411-12.493 27.903-27.903 27.903S71.59 72.741 71.59 57.331c0-1.283.152-2.537.319-3.775"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4",
    gradientUnits: "userSpaceOnUse",
    x1: 56.21,
    y1: 57.987,
    x2: 143.722,
    y2: 57.987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.87 93.903c-8.417-2.525-14.411-9.204-14.411-9.204s2.946-1.683 5.471-7.154.943-20.322.943-20.322c0-19.729 15.993-35.722 35.722-35.722s35.722 15.993 35.722 35.722c0 0-.842 15.272 2.946 21.795 1.683 3.367 4.209 5.682 4.209 5.682s-5.914 5.986-14.331 9.774",
    fill: "none",
    stroke: "url(#SVGID_1_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4",
    gradientUnits: "userSpaceOnUse",
    x1: 71.01,
    y1: 47.91,
    x2: 128.431,
    y2: 47.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.26 53.556s6.593.491 16.624-2.104c10.1-2.525 20.061-9.96 20.061-9.96s6.593 11.153 18.237 12.836",
    fill: "none",
    stroke: "url(#SVGID_2_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4",
    gradientUnits: "userSpaceOnUse",
    x1: 106.602,
    y1: 119.882,
    x2: 134.44,
    y2: 119.882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_367b8b91c763859d8d5056a20d1e1efc7d2d2c70370ec1107512091d9309b3d4)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M107.852 111.006h25.337v17.75h-25.337z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M112.546 115.686h8.551v8.551h-8.551z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M51.464 128.887c2.327-24.488 22.95-43.643 48.046-43.643 24.976 0 45.521 18.971 48.012 43.289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.83dd12c3c73ce48df93a5180fc487044.svg";
export { ForwardRef as ReactComponent };